"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatTransaction = exports.toTransactionRaw = exports.fromTransactionRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var common_1 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var fromTransactionRaw = function (tr) {
    var common = (0, common_1.fromTransactionCommonRaw)(tr);
    var networkInfo = tr.networkInfo;
    return __assign(__assign({}, common), { networkInfo: networkInfo && {
            family: "tron",
            freeNetUsed: new bignumber_js_1.BigNumber(networkInfo.freeNetUsed),
            freeNetLimit: new bignumber_js_1.BigNumber(networkInfo.freeNetLimit),
            netUsed: new bignumber_js_1.BigNumber(networkInfo.netUsed),
            netLimit: new bignumber_js_1.BigNumber(networkInfo.netLimit),
            energyUsed: new bignumber_js_1.BigNumber(networkInfo.energyUsed),
            energyLimit: new bignumber_js_1.BigNumber(networkInfo.energyLimit)
        }, family: tr.family, mode: tr.mode, resource: tr.resource || null, duration: tr.duration || 3, votes: tr.votes });
};
exports.fromTransactionRaw = fromTransactionRaw;
var toTransactionRaw = function (t) {
    var common = (0, common_1.toTransactionCommonRaw)(t);
    var networkInfo = t.networkInfo;
    return __assign(__assign({}, common), { networkInfo: networkInfo && {
            family: "tron",
            freeNetUsed: networkInfo.freeNetUsed.toString(),
            freeNetLimit: networkInfo.freeNetLimit.toString(),
            netUsed: networkInfo.netUsed.toString(),
            netLimit: networkInfo.netLimit.toString(),
            energyUsed: networkInfo.energyUsed.toString(),
            energyLimit: networkInfo.energyLimit.toString()
        }, family: t.family, mode: t.mode, resource: t.resource || null, duration: t.duration || 3, votes: t.votes });
};
exports.toTransactionRaw = toTransactionRaw;
var formatTransaction = function (t, mainAccount) {
    var account = (t.subAccountId &&
        (mainAccount.subAccounts || []).find(function (a) { return a.id === t.subAccountId; })) ||
        mainAccount;
    return "\n".concat(t.mode.toUpperCase()).concat(t.resource ? " " + t.resource : "", " ").concat(t.useAllAmount
        ? "MAX"
        : t.amount.isZero()
            ? ""
            : " " +
                (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), t.amount, {
                    showCode: true,
                    disableRounding: true
                })).concat(!t.votes
        ? ""
        : " " + t.votes.map(function (v) { return v.voteCount + "->" + v.address; }).join(" "), "\nTO ").concat(t.recipient);
};
exports.formatTransaction = formatTransaction;
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: exports.fromTransactionRaw,
    toTransactionRaw: exports.toTransactionRaw
};
//# sourceMappingURL=transaction.js.map